import {
  useEffect,
} from "react";

import {
  useLocation,
} from "react-router-dom";

/*
  ============================================================
  PHOTOGRAPHY PREMIUM
  Scroll to top on route change
  ============================================================

  React Router säilyttää normaalisti nykyisen scroll-position.

  Kun käyttäjä siirtyy esimerkiksi footerista:
  / -> /portfolio

  uusi sivu palautetaan automaattisesti alkuun.
*/

export default function ScrollToTopOnRouteChange() {
  const {
    pathname,
  } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto",
    });
  }, [
    pathname,
  ]);

  return null;
}